import { makeStyles } from '@material-ui/core/styles';

import cursor from '../../assets/cursor.svg';

const url = `url('${cursor}'), auto`;


export const useImageInputAndDisplayAnonymousStyles = makeStyles({

    imageHolder: {
        marginBottom: '64px',
        marginTop: '64px',
        width: '176px',
        height: '172px',
        border: '1px solid #F2F2F2',
        borderRadius: '12px',
        opacity: 1,
    },

    holder: {
        marginBottom: '64px',
        marginTop: '64px',
        width: '176px',
        height: '172px',
        border: '1px solid #F2F2F2',
        borderRadius: '12px',
        opacity: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
    },

    imageButton: {
        width: '40px',
        height: '40px',
        borderRadius: '6px',
        opacity: 1,
        marginBottom: '16px',
        marginRight: '12px',
        minWidth: 'unset',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: '#A9AAAB',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        cursor: url,
    },

});

export const imageStyle = {
    objectFit: 'cover',
    width: '176px',
    height: '172px',
    borderRadius: '12px',
};
